// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VljaoYGeUEAudAciy53j{font-feature-settings:"tnum" 1;font-family:"geomanist",sans-serif}`, "",{"version":3,"sources":["webpack://./src/components/Countdown.scss"],"names":[],"mappings":"AAAA,sBACC,8BAAA,CACG,kCAAA","sourcesContent":[".countdown {\r\n\tfont-feature-settings: \"tnum\" 1;\r\n    font-family: 'geomanist', sans-serif;\r\n}"],"sourceRoot":""}]);
// Exports
export var countdown = `VljaoYGeUEAudAciy53j`;
export default ___CSS_LOADER_EXPORT___;
